import styled, { css } from "styled-components";

export const h1Css = css`
  font-family: "Aeonik - Regular";
  font-style: normal;
  font-weight: 400;
  font-size: 55px;
  line-height: 66px;
  @media ${({ theme }) => theme.breakpoints.sm} {
    font-size: 26px;
    line-height: 31.2px;
  }
`;

export const h1 = styled.h1`
  ${h1Css}
`;

export const h2Css = css`
  font-family: "Aeonik - Regular";
  font-style: normal;
  font-weight: 400;
  font-size: 55px;
  line-height: 66px;
  @media ${({ theme }) => theme.breakpoints.sm} {
    font-size: 26px;
    line-height: 31.2px;
  }
`;

export const h2 = styled.h2`
  ${h2Css}
`;

export const h3Css = css`
  font-family: "Aeonik - Regular";
  font-style: normal;
  font-weight: 100;
  font-size: 20px;
  line-height: 24px;
`;

export const h3 = styled.h3`
  ${h3Css}
`;

export const paragraphCss = css`
  font-family: "Aeonik - Thin";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  -webkit-font-smoothing: antialiased;
  @media ${({ theme }) => theme.breakpoints.sm} {
    font-size: 16px;
    line-height: 21px;
  }
`;

export const paragraph = styled.p`
  ${paragraphCss}
`;

export const detailsBigCss = css`
  font-family: "Aeonik - Regular";
  font-style: normal;
  font-size: 30px;
  line-height: 42px;
  @media ${({ theme }) => theme.breakpoints.sm} {
    font-size: 18px;
    line-height: 23px;
  }
`;

export const detailsBig = styled.p`
  ${detailsBigCss}
`;

export const WysiwygCss = css`
  margin-bottom: 100px;
  p {
    ${paragraphCss}
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-bottom: 10px;
  }
  h1 {
    ${h1Css}
  }
  h2 {
    ${h2Css}
  }
  h3 {
    ${h2Css}
  }
  h4 {
    ${h2Css}
  }
  h5 {
    ${h2Css}
  }
  h6 {
    ${h2Css}
  }

  ul {
    padding: 0;
    margin: 0;
  }

  li {
    ${paragraphCss}
    margin-bottom: 10px;
    margin-left: 40px;
  }

  a {
    color: ${({ theme }) => theme.colors.softBlack};
    text-decoration: none;
    border-bottom: 1px solid ${({ theme }) => theme.colors.softBlack};
    transition: border-bottom 0.2s ease-in-out;
  }

  img {
    max-width: 100%;
  }

  blockquote {
    ${paragraphCss}
    margin: 0;
    padding: 0;
    border-left: 4px solid ${({ theme }) => theme.colors.softBlack};
    padding-left: 20px;
  }

  strong {
    font-family: sans-serif;
  }

  em {
    font: sans-serif italic;
  }
`;

export const Wysiwyg = styled.div`
  ${WysiwygCss}
`;
